export const productCarouselData = [
    {
        "sku": "1W2Y8A#B1H",
        "group_id": "1W2Y8A#B1H",
        "categories": [
            "Printers",
            "HP ENVY",
            "HP ENVY"
        ],
        "keywords": [
            "FUNCTIONS-Multifunction / All",
            "COLOR OUTPUT-Color",
            "TYPE-InkJet",
            "BRAND-ENVY",
            "TWO-SIDED PRINTING-Yes",
            "PRINTING PROGRAMS-HP Instant Ink eligible",
            "Print Speed Black (normal, letter)-Up to 15 ppm",
            "Print Speed Color (normal, letter)-Up to 10 ppm",
            "Recommended Monthly Page Volume-300 to 400",
            "Connectivity, Std-1 USB 2.0 client; 1 Wi"
        ],
        "publish_time": "2024-08-19T16:15:49",
        "name": "HP ENVY Inspire 7955e All-in-One Printer with Bonus 3 Months of Instant Ink with HP+",
        "url": "https://www.hp.com/us-en/shop/pdp/hp-envy-inspire-7955e-all-in-one-printer",
        "image_url": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c07900539.png",
        "price": 159.99,
        "dy_display_price": "159.99",
        "category_subbrand": "ENVY",
        "category_custom": "Inkjet All-in-One Printers",
        "category_usage": "Home and home office",
        "catid": "3074457345620129827",
        "productmargin": "32.36",
        "catentryId": "3074457345620129827",
        "images": [
            {
                "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c07900539.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/hp-envy-inspire-7955e-all-in-one-printer",
        "dyItemTracking": {
            "data-dy-product-id": "1W2Y8A#B1H",
            "data-dy-strategy-id": 9
        }
    },
    {
        "sku": "8L7H1AV_1",
        "group_id": "8L7H1AV_1",
        "categories": [
            "Laptops",
            "HP Envy",
            "HP Envy 17"
        ],
        "keywords": [
            "OPERATING SYSTEM-Windows 11 Home",
            "PROCESSOR-Intel Core Ultra 5",
            "GRAPHICS-Intel Arc",
            "MEMORY-16 GB",
            "STORAGE-512 GB",
            "SOLID STATE DRIVE-Yes",
            "SCREEN SIZE-17\"",
            "FORM FACTOR-Standard laptop",
            "TOUCH SCREEN-Non",
            "BRAND-ENVY",
            "USAGE-Premium computing"
        ],
        "publish_time": "2024-08-19T16:15:49",
        "name": "HP ENVY Laptop 17t-cw100, 17.3\"",
        "url": "https://www.hp.com/us-en/shop/pdp/hp-envy-laptop-17t-cw100-173-8l7h1av-1",
        "image_url": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08893709.png",
        "price": 1149.99,
        "dy_display_price": "1149.99",
        "category_subbrand": "ENVY",
        "category_custom": "HP Home Laptop PCs",
        "category_usage": "Premium computing",
        "catid": "3074457345621192322",
        "productmargin": "1149.99",
        "catentryId": "3074457345621192322",
        "images": [
            {
                "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08893709.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/hp-envy-laptop-17t-cw100-173-8l7h1av-1",
        "dyItemTracking": {
            "data-dy-product-id": "8L7H1AV_1",
            "data-dy-strategy-id": 9
        }
    },
    {
        "sku": "7K635AV_1",
        "group_id": "7K635AV_1",
        "categories": [
            "Laptops",
            "HP Spectre",
            "HP Spectre x360 14"
        ],
        "keywords": [
            "OPERATING SYSTEM-Windows 11 Home",
            "PROCESSOR-Intel Core Ultra 5",
            "GRAPHICS-Intel Arc",
            "MEMORY-16 GB",
            "STORAGE-512 GB",
            "SOLID STATE DRIVE-Yes",
            "SCREEN SIZE-14\"",
            "FORM FACTOR-Convertible",
            "TOUCH SCREEN-Touch",
            "BRAND-Spectre",
            "USAGE-Premium computing"
        ],
        "in_stock": true,
        "publish_time": "2024-08-19T16:15:49",
        "name": "HP Spectre x360 2-in-1 Laptop 14t-eu000, 14\"",
        "url": "https://www.hp.com/us-en/shop/pdp/hp-spectre-x360-2-in-1-laptop-14t-eu000-14-7k635av-1",
        "image_url": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08873717.png",
        "price": 1449.99,
        "dy_display_price": "1449.99",
        "category_subbrand": "Spectre",
        "category_custom": "HP Home Laptop PCs",
        "category_usage": "Premium computing",
        "catid": "3074457345621114322",
        "productmargin": "1449.99",
        "catentryId": "3074457345621114322",
        "images": [
            {
                "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08873717.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/hp-spectre-x360-2-in-1-laptop-14t-eu000-14-7k635av-1",
        "dyItemTracking": {
            "data-dy-product-id": "7K635AV_1",
            "data-dy-strategy-id": 9
        }
    },
    {
        "sku": "59A32AV_1",
        "group_id": "59A32AV_1",
        "categories": [
            "Desktops",
            "Victus by HP",
            "Victus by HP 15L Gaming Desktop"
        ],
        "keywords": [
            "OPERATING SYSTEM-Windows 11 Home",
            "PROCESSOR-AMD Ryzenâ„¢ 5",
            "GRAPHICS-AMD Radeon",
            "MEMORY-Other",
            "STORAGE-Other",
            "SOLID STATE DRIVE-Yes",
            "FORM FACTOR-Tower",
            "BRAND-Victus by HP",
            "USAGE-Gaming"
        ],
        "in_stock": true,
        "publish_time": "2024-08-19T16:15:49",
        "name": "Victus by HP 15L Gaming Desktop TG02-0325m",
        "url": "https://www.hp.com/us-en/shop/pdp/victus-by-hp-15l-gaming-desktop-tg02-0325m-59a32av-1",
        "image_url": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08013385.png",
        "price": 479.99,
        "dy_display_price": "479.99",
        "category_subbrand": "Victus by HP",
        "category_custom": "HP Home Desktop PCs",
        "category_usage": "Gaming",
        "catid": "3074457345620235323",
        "productmargin": "479.99",
        "catentryId": "3074457345620235323",
        "images": [
            {
                "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08013385.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/victus-by-hp-15l-gaming-desktop-tg02-0325m-59a32av-1",
        "dyItemTracking": {
            "data-dy-product-id": "59A32AV_1",
            "data-dy-strategy-id": 9
        }
    },
    {
        "sku": "F6U64AN#140",
        "group_id": "F6U64AN#140",
        "categories": [
            "Ink, toner & paper",
            "Ink cartridges",
            "HP 63 Ink Cartridges"
        ],
        "keywords": [
            "Print Cartridge, Color(s)-Black",
            "Average Page Yield For A4 Format, Black and White-~430 pages",
            "Ink Drop-22 pl"
        ],
        "in_stock": true,
        "publish_time": "2024-08-19T16:15:49",
        "name": "HP 63XL High Yield Black Original Ink Cartridge, F6U64AN#140",
        "url": "https://www.hp.com/us-en/shop/pdp/hp-63xl-high-yield-black-original-ink-cartridge",
        "image_url": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c06674177.png",
        "price": 50.99,
        "dy_display_price": "50.99",
        "category_subbrand": "",
        "category_custom": "Ink Supplies",
        "category_usage": "",
        "catid": "863157",
        "productmargin": "43.42",
        "catentryId": "863157",
        "images": [
            {
                "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c06674177.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/hp-63xl-high-yield-black-original-ink-cartridge",
        "dyItemTracking": {
            "data-dy-product-id": "F6U64AN#140",
            "data-dy-strategy-id": 9
        }
    },
    {
        "sku": "7P3Q0AV_1",
        "group_id": "7P3Q0AV_1",
        "categories": [
            "Laptops",
            "HP Essential",
            "HP Laptop"
        ],
        "keywords": [
            "OPERATING SYSTEM-Windows 11 Home",
            "PROCESSOR-Intel Core i5",
            "GRAPHICS-Intel Iris",
            "MEMORY-8 GB",
            "STORAGE-512 GB",
            "SOLID STATE DRIVE-Yes",
            "SCREEN SIZE-17\"",
            "FORM FACTOR-Standard laptop",
            "TOUCH SCREEN-Non",
            "BRAND-Essential",
            "USAGE-Everyday computing"
        ],
        "in_stock": true,
        "publish_time": "2024-08-19T16:15:49",
        "name": "HP Laptop 17t-cn300, 17.3\"",
        "url": "https://www.hp.com/us-en/shop/pdp/hp-laptop-17t-cn300-173-7p3q0av-1",
        "image_url": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c07051091.png",
        "price": 399.99,
        "dy_display_price": "399.99",
        "category_subbrand": "Essential",
        "category_custom": "HP Home Laptop PCs",
        "category_usage": "Everyday computing",
        "catid": "3074457345620895819",
        "productmargin": "399.99",
        "catentryId": "3074457345620895819",
        "images": [
            {
                "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c07051091.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/hp-laptop-17t-cn300-173-7p3q0av-1",
        "dyItemTracking": {
            "data-dy-product-id": "7P3Q0AV_1",
            "data-dy-strategy-id": 9
        }
    },
    {
        "sku": "94G34AV_1",
        "group_id": "94G34AV_1",
        "categories": [
            "Laptops",
            "HP Pavilion",
            "HP Pavilion 16"
        ],
        "keywords": [
            "OPERATING SYSTEM-Windows 11 Home",
            "PROCESSOR-Intel Core 5",
            "GRAPHICS-Intel Graphics",
            "MEMORY-Other",
            "STORAGE-512 GB",
            "SOLID STATE DRIVE-Yes",
            "SCREEN SIZE-16\"",
            "FORM FACTOR-Standard laptop",
            "TOUCH SCREEN-Non",
            "BRAND-Pavilion",
            "USAGE-Everyday computing"
        ],
        "in_stock": true,
        "publish_time": "2024-08-19T16:15:49",
        "name": "HP Pavilion Laptop 16t-af000, 16\"",
        "url": "https://www.hp.com/us-en/shop/pdp/hp-pavilion-laptop-16t-af000-16-94g34av-1",
        "image_url": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08943519.png",
        "price": 849.99,
        "dy_display_price": "849.99",
        "category_subbrand": "Pavilion",
        "category_custom": "HP Home Laptop PCs",
        "category_usage": "Everyday computing",
        "catid": "3074457345621247819",
        "productmargin": "849.99",
        "catentryId": "3074457345621247819",
        "images": [
            {
                "image": "https://ssl-product-images.www8-hp.com/digmedialib/prodimg/lowres/c08943519.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/hp-pavilion-laptop-16t-af000-16-94g34av-1",
        "dyItemTracking": {
            "data-dy-product-id": "94G34AV_1",
            "data-dy-strategy-id": 9
        }
    },
    {
        "sku": "E45c_Modern_Leader_Kit",
        "group_id": "E45c_Modern_Leader_Kit",
        "categories": [
            "No Default Category"
        ],
        "keywords": [],
        "in_stock": true,
        "publish_time": "2024-08-19T16:15:49",
        "name": "Modern Leader E45c Bundle",
        "url": "https://www.hp.com/us-en/shop/pdp/hp-e45c-445-dqhd-curved-monitor-poly-headset-hp-thunderbolt-g4-dock-poly-speakerphone-hp-wireless-keyboard-mouse-bundle-e45c-modern-leader-kit",
        "image_url": "https://www.hp.com/wcsstore/hpusstore/Banners/bundles/E45c_Modern_Leader_Kit_573x430.png",
        "price": 1549.99,
        "dy_display_price": "1549.99",
        "category_subbrand": "",
        "category_custom": "",
        "category_usage": "",
        "catid": "3074457345621334820",
        "productmargin": "-26282.37",
        "catentryId": "3074457345621334820",
        "images": [
            {
                "image": "https://www.hp.com/wcsstore/hpusstore/Banners/bundles/E45c_Modern_Leader_Kit_573x430.png"
            }
        ],
        "productUrl": "https://www.hp.com/us-en/shop/pdp/hp-e45c-445-dqhd-curved-monitor-poly-headset-hp-thunderbolt-g4-dock-poly-speakerphone-hp-wireless-keyboard-mouse-bundle-e45c-modern-leader-kit",
        "dyItemTracking": {
            "data-dy-product-id": "E45c_Modern_Leader_Kit",
            "data-dy-strategy-id": 9
        }
    }
];